import { Provider } from '@angular/core'

import { MarkedOptions } from 'marked'
import { MARKED_OPTIONS } from 'ngx-markdown'

const EXTERNAL_HREF = /^https?:\/\//i

// Open external (http/https) links in a new tab so the chat stays open when a
// user clicks a cited source (e.g. an IntellaQuest QRQC link). Relative /
// in-app links keep the default same-tab behaviour.
//
// We pass a plain-object renderer override (NOT a `new Renderer()` instance):
// ngx-markdown shallow-clones the renderer (`{ ...renderer }`) before handing
// it to marked, which strips the prototype chain off a class instance and
// breaks every inherited method (`table`, `tablerow`, `tablecell`, …). The
// override below only sets `link`, so marked.use() merges it with its default
// renderer and the rest of the rendering keeps working.
const linkOverride = {
  link({ href, title, text }: { href: string; title?: string | null; text: string }): string {
    const titleAttr = title ? ` title="${title}"` : ''
    const targetAttr = EXTERNAL_HREF.test(href) ? ' target="_blank" rel="noopener noreferrer"' : ''
    return `<a href="${href}"${titleAttr}${targetAttr}>${text}</a>`
  }
}

export const provideMarkdownCustomRenderer = (): Provider => {
  return {
    provide: MARKED_OPTIONS,
    useFactory: (): MarkedOptions => ({
      gfm: true,
      breaks: true,
      renderer: linkOverride as unknown as MarkedOptions['renderer']
    })
  }
}
